/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { CollectionsList } from "../../../../_start/partials/widgets/tables/CollectionsList";
import { CreateAppModal } from "../_modals/create-app-stepper/CreateAppModal";

export const StartDashboardPage: React.FC = () => {
  const [show, setShow] = useState(false);
  return (
    <>
      {/* begin::Row */}
      <div className="row g-0 g-xl-12 g-xxl-12">
        <div className="col-xl-12">
          <CollectionsList className="card-stretch mb-5 mb-xxl-12" />
        </div>
      </div>
      {/* end::Row */}

      {/* begin::Modals */}
      <CreateAppModal show={show} handleClose={() => setShow(false)} />
      {/* end::Modals */}
    </>
  );
};
